import { GeneralTreatingPhysicianFieldController } from "./general-treating-physician-field-controller";

export class TreatingPhysicianPlaceFieldController extends GeneralTreatingPhysicianFieldController {}
